<template>
  <li class="divider"></li>
</template>
<script>
  export default {
    name: 'DropdownDivider'
  }
</script>



// WEBPACK FOOTER //
// dropdown-divider.vue?3992be7e